import DeluxeHydraFacialIcon from '../../assets/icons/services/deluxe-hydrafacial.svg'
import FullEditFacialIcon from '../../assets/icons/services/full-edit-facial.svg'
import PlatinumHydraFacialIcon from '../../assets/icons/services/platinum-hydrafacial.svg'
import EliteLaserFacialIcon from '../../assets/icons/services/the-elite-laser-facial.svg'
import EssentialFacialIcon from '../../assets/icons/services/the-essential-facial.svg'
import MicroNeedlingFacialIcon from '../../assets/icons/services/the-microneedling-facial.svg'

export const serviceIDs = process.env.REACT_APP_SERVICE_IDS?.split(',')

export const influencerFacialId = process.env.REACT_APP_INFLUENCER_FACIAL_ID

export const services = [
  {
    id: serviceIDs?.[0],
    name: 'The Essential Facial',
    label: 'The Essential Facial',
    short:
      "50 minutes. A facial deeply customized to your skin's needs today, from acne to",
    long: "50 minutes. A facial deeply customized to your skin's needs today, from acne to aging concerns. Expect a skin analysis and personalized treatment each time.",
    isLaser: false,
    hideMemberPrice: false,
    isMembershipPrice: true,
    icon: EssentialFacialIcon,
    isNew: false,
    isMicro: false,
    order: 1,
  },
  {
    id: serviceIDs?.[4],
    name: 'Deluxe Hydrafacial',
    label: 'Deluxe Hydrafacial',
    short:
      '50 minutes. A medical-grade treatment that deeply cleanses, exfoliates, extracts',
    long: '50 minutes. A medical-grade treatment that deeply cleanses, exfoliates, extracts impurities, and infuses intensive hydration for instantly radiant skin&mdash;for clients seeking solutions to specific skin concerns.',
    isLaser: false,
    isMicro: false,
    hideMemberPrice: false,
    isMembershipPrice: true,
    icon: DeluxeHydraFacialIcon,
    isNew: true,
    order: 3,
  },
  {
    id: serviceIDs?.[4],
    name: 'Deluxe Hydrafacial Training Facial',
    label: 'Deluxe Hydrafacial Training Facial',
    short:
      '50 minutes. A medical-grade treatment that deeply cleanses, exfoliates, extracts',
    long: '50 minutes. A medical-grade treatment that deeply cleanses, exfoliates, extracts impurities, and infuses intensive hydration for instantly radiant skin&mdash;for clients seeking solutions to specific skin concerns.',
    isLaser: false,
    isMicro: false,
    hideMemberPrice: false,
    isMembershipPrice: true,
    icon: DeluxeHydraFacialIcon,
    isNew: true,
    order: 3,
  },
  {
    id: serviceIDs?.[5],
    name: 'Platinum Hydrafacial',
    label: 'Platinum Hydrafacial',
    short:
      '50 minutes. The Deluxe Hydrafacial experience enhanced with rejuvenating lymphatic',
    long: '50 minutes. The Deluxe Hydrafacial experience enhanced with rejuvenating lymphatic therapy to lift, contour and detoxify&mdash;for clients who want a complete skin reset.',
    isLaser: false,
    isMicro: false,
    hideMemberPrice: false,
    isMembershipPrice: true,
    icon: PlatinumHydraFacialIcon,
    isNew: true,
    order: 4,
  },
  {
    id: serviceIDs?.[5],
    name: 'Platinum Hydrafacial Training Facial',
    label: 'Platinum Hydrafacial Training Facial',
    short:
      '50 minutes. The Deluxe Hydrafacial experience enhanced with rejuvenating lymphatic',
    long: '50 minutes. The Deluxe Hydrafacial experience enhanced with rejuvenating lymphatic therapy to lift, contour and detoxify&mdash;for clients who want a complete skin reset.',
    isLaser: false,
    isMicro: false,
    hideMemberPrice: false,
    isMembershipPrice: true,
    icon: PlatinumHydraFacialIcon,
    isNew: true,
    order: 4,
  },
  {
    id: serviceIDs?.[6],
    name: 'The Full Edit Facial',
    label: 'The Full Edit Facial',
    short:
      '100 minutes. Indulge in a full-scope facial that pairs deep relaxation with high-performance',
    long: '100 minutes. Indulge in a full-scope facial that pairs deep relaxation with high-performance treatments designed to deliver serious skin results.',
    isLaser: false,
    isMicro: false,
    hideMemberPrice: false,
    isMembershipPrice: true,
    icon: FullEditFacialIcon,
    isNew: true,
    order: 5,
  },
  {
    id: serviceIDs?.[1],
    name: 'The Elite Laser Facial',
    label: 'The Elite Laser Facial',
    short:
      '50 minutes. A Laser treatment calibrated to your exact melanin levels to',
    long: '50 minutes. A Laser treatment calibrated to your exact melanin levels to safely firm, brighten, and clear skin. Powered by the gold-standard Cynosure Elite iQ<sup>&#174;</sup>.',
    isLaser: true,
    hideMemberPrice: false,
    isMembershipPrice: true,
    icon: EliteLaserFacialIcon,
    isNew: false,
    isMicro: false,
    order: 6,
  },
  {
    id: serviceIDs?.[2],
    name: 'First Time Laser Facial',
    label: 'First Time Laser Facial',
    short:
      'We will analyze your skin, determine the right Laser settings based on your skin type',
    long: `We will analyze your skin, determine the right Laser settings based on your skin type and goals, and conduct an introductory laser treatment to understand your skin's response. You'll leave with a personalized treatment plan for optimal results.
    
This introductory price cannot be combined with any other first-time facial offer.`,
    isLaser: true,
    hideMemberPrice: true,
    isMembershipPrice: false,
    icon: EliteLaserFacialIcon,
    isNew: false,
    isMicro: false,
    order: 7,
  },
  {
    id: serviceIDs?.[3],
    name: 'Microneedling',
    label: 'The Microneedling Facial',
    short:
      '50 minutes. The only Microneedling treatment featuring FDA-cleared digital calibration',
    long: '50 minutes. The only Microneedling treatment featuring FDA-cleared digital calibration for superior precision. Targets aging, pigmentation, and acne.',
    isLaser: false,
    isMicro: true,
    hideMemberPrice: false,
    isMembershipPrice: true,
    icon: MicroNeedlingFacialIcon,
    isNew: false,
    order: 8,
  },
]
